import { LayoutDashboard } from "lucide-react";
import React from "react";
import { NavLink } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";

export default function Menu() {
  const currentRole = useAppSelector(
    (state) => state.user.userProfile?.currentRole ?? null
  );
  return (
    <ul className="flex flex-1 flex-col gap-y-8 py-2">
      <li className="flex-grow">
        <ul className="-mx-2 space-y-1">
          {currentRole === "SALES_TEAM_LEAD" && (
            <>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "sidebar-link text-white bg-primary-dark"
                      : "sidebar-link text-gray-600 hover:text-primary-dark"
                  }
                  to="/dashboard"
                  end
                >
                  <LayoutDashboard />
                  Dashboard
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "sidebar-link text-white bg-primary-dark"
                      : "sidebar-link text-gray-600 hover:text-primary-dark"
                  }
                  to="/lead-management"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 32 32"
                    className="h-6 w-6 shrink-0"
                    fill="currentColor"
                  >
                    <path d="M28.5005 8C28.0934 8.00011 27.6926 8.0996 27.3327 8.28983C26.9729 8.48006 26.6649 8.75529 26.4356 9.09159C26.2063 9.42789 26.0625 9.81509 26.0169 10.2196C25.9712 10.624 26.025 11.0335 26.1736 11.4125L20.913 16.6731C20.3265 16.4423 19.6744 16.4423 19.088 16.6731L15.3273 12.9125C15.4763 12.5335 15.5303 12.1238 15.4848 11.7191C15.4393 11.3144 15.2957 10.9269 15.0663 10.5904C14.8369 10.2539 14.5289 9.97849 14.1688 9.78817C13.8088 9.59785 13.4077 9.49836 13.0005 9.49836C12.5932 9.49836 12.1921 9.59785 11.8321 9.78817C11.4721 9.97849 11.164 10.2539 10.9346 10.5904C10.7053 10.9269 10.5616 11.3144 10.5161 11.7191C10.4706 12.1238 10.5247 12.5335 10.6736 12.9125L4.41297 19.1731C3.87829 18.9634 3.28771 18.9441 2.74051 19.1186C2.19332 19.2931 1.72289 19.6507 1.40832 20.1312C1.09375 20.6117 0.954235 21.1859 1.01323 21.7572C1.07222 22.3285 1.32612 22.8621 1.73224 23.2682C2.13836 23.6743 2.67193 23.9283 3.24323 23.9872C3.81453 24.0462 4.38872 23.9067 4.86926 23.5921C5.34979 23.2776 5.70736 22.8071 5.88185 22.26C6.05633 21.7128 6.03708 21.1222 5.82734 20.5875L12.088 14.3269C12.6744 14.5577 13.3265 14.5577 13.913 14.3269L17.6736 18.0875C17.5247 18.4665 17.4706 18.8762 17.5161 19.2809C17.5616 19.6856 17.7053 20.0731 17.9346 20.4096C18.164 20.7461 18.4721 21.0215 18.8321 21.2118C19.1921 21.4022 19.5932 21.5016 20.0005 21.5016C20.4077 21.5016 20.8088 21.4022 21.1688 21.2118C21.5289 21.0215 21.837 20.7461 22.0663 20.4096C22.2957 20.0731 22.4393 19.6856 22.4848 19.2809C22.5303 18.8762 22.4763 18.4665 22.3273 18.0875L27.588 12.8269C27.9303 12.9614 28.2981 13.0187 28.6651 12.9947C29.0321 12.9707 29.3893 12.866 29.7112 12.6882C30.0331 12.5103 30.3118 12.2636 30.5274 11.9656C30.7431 11.6676 30.8903 11.3258 30.9586 10.9644C31.0269 10.603 31.0147 10.231 30.9227 9.87487C30.8307 9.51876 30.6613 9.18733 30.4265 8.90422C30.1918 8.6211 29.8974 8.39327 29.5645 8.23697C29.2316 8.08067 28.8683 7.99976 28.5005 8Z" />
                  </svg>
                  Lead Management
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "sidebar-link text-white bg-primary-dark"
                      : "sidebar-link text-gray-600 hover:text-primary-dark"
                  }
                  to="/reports"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="none"
                    strokeWidth="0.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-6 w-6 shrink-0"
                  >
                    <path
                      d="M11.5 6C10.5729 6.00369 9.68478 6.37362 9.0292 7.0292C8.37362 7.68478 8.00369 8.57288 8 9.5C8 11.422 9.578 13 11.5 13C13.422 13 15 11.422 15 9.5C15 7.578 13.422 6 11.5 6ZM20.5 6C19.5729 6.00369 18.6848 6.37362 18.0292 7.0292C17.3736 7.68478 17.0037 8.57288 17 9.5C17 11.422 18.578 13 20.5 13C22.422 13 24 11.422 24 9.5C24 7.578 22.422 6 20.5 6ZM11.5 8C12.34 8 13 8.66 13 9.5C13 10.34 12.34 11 11.5 11C10.66 11 10 10.34 10 9.5C10 8.66 10.66 8 11.5 8ZM20.5 8C21.34 8 22 8.66 22 9.5C22 10.34 21.34 11 20.5 11C19.66 11 19 10.34 19 9.5C19 8.66 19.66 8 20.5 8ZM7 12C4.8 12 3 13.8 3 16C3 17.113 3.477 18.117 4.219 18.844C3.53832 19.3033 2.98029 19.9221 2.59353 20.6465C2.20677 21.3709 2.00301 22.1788 2 23H4C4 21.332 5.332 20 7 20C8.668 20 10 21.332 10 23H12C11.997 22.1788 11.7932 21.3709 11.4065 20.6465C11.0197 19.9221 10.4617 19.3033 9.781 18.844C10.523 18.117 11 17.114 11 16C11 13.8 9.2 12 7 12ZM12 23C11.375 23.836 11 24.887 11 26H13C13 24.332 14.332 23 16 23C17.668 23 19 24.332 19 26H21C20.9983 24.9184 20.6476 23.8663 20 23C19.66 22.547 19.25 22.16 18.781 21.844C19.523 21.117 20 20.114 20 19C20 16.8 18.2 15 16 15C13.8 15 12 16.8 12 19C12 20.113 12.477 21.117 13.219 21.844C12.7509 22.1585 12.3388 22.5492 12 23ZM20 23H22C22 21.332 23.332 20 25 20C26.668 20 28 21.332 28 23H30C29.997 22.1788 29.7932 21.3709 29.4065 20.6465C29.0197 19.9221 28.4617 19.3033 27.781 18.844C28.523 18.117 29 17.114 29 16C29 13.8 27.2 12 25 12C22.8 12 21 13.8 21 16C21 17.113 21.477 18.117 22.219 18.844C21.5383 19.3033 20.9803 19.9221 20.5935 20.6465C20.2068 21.3709 20.003 22.1788 20 23ZM7 14C8.117 14 9 14.883 9 16C9 17.117 8.117 18 7 18C5.883 18 5 17.117 5 16C5 14.883 5.883 14 7 14ZM25 14C26.117 14 27 14.883 27 16C27 17.117 26.117 18 25 18C23.883 18 23 17.117 23 16C23 14.883 23.883 14 25 14ZM16 17C17.117 17 18 17.883 18 19C18 20.117 17.117 21 16 21C14.883 21 14 20.117 14 19C14 17.883 14.883 17 16 17Z"
                      fill="#fff"
                    />
                  </svg>
                  Reports
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "sidebar-link text-white bg-primary-dark"
                      : "sidebar-link text-gray-600 hover:text-primary-dark"
                  }
                  to="/campaigns"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="none"
                    strokeWidth="0.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-6 w-6 shrink-0"
                  >
                    <path
                      d="M11.5 6C10.5729 6.00369 9.68478 6.37362 9.0292 7.0292C8.37362 7.68478 8.00369 8.57288 8 9.5C8 11.422 9.578 13 11.5 13C13.422 13 15 11.422 15 9.5C15 7.578 13.422 6 11.5 6ZM20.5 6C19.5729 6.00369 18.6848 6.37362 18.0292 7.0292C17.3736 7.68478 17.0037 8.57288 17 9.5C17 11.422 18.578 13 20.5 13C22.422 13 24 11.422 24 9.5C24 7.578 22.422 6 20.5 6ZM11.5 8C12.34 8 13 8.66 13 9.5C13 10.34 12.34 11 11.5 11C10.66 11 10 10.34 10 9.5C10 8.66 10.66 8 11.5 8ZM20.5 8C21.34 8 22 8.66 22 9.5C22 10.34 21.34 11 20.5 11C19.66 11 19 10.34 19 9.5C19 8.66 19.66 8 20.5 8ZM7 12C4.8 12 3 13.8 3 16C3 17.113 3.477 18.117 4.219 18.844C3.53832 19.3033 2.98029 19.9221 2.59353 20.6465C2.20677 21.3709 2.00301 22.1788 2 23H4C4 21.332 5.332 20 7 20C8.668 20 10 21.332 10 23H12C11.997 22.1788 11.7932 21.3709 11.4065 20.6465C11.0197 19.9221 10.4617 19.3033 9.781 18.844C10.523 18.117 11 17.114 11 16C11 13.8 9.2 12 7 12ZM12 23C11.375 23.836 11 24.887 11 26H13C13 24.332 14.332 23 16 23C17.668 23 19 24.332 19 26H21C20.9983 24.9184 20.6476 23.8663 20 23C19.66 22.547 19.25 22.16 18.781 21.844C19.523 21.117 20 20.114 20 19C20 16.8 18.2 15 16 15C13.8 15 12 16.8 12 19C12 20.113 12.477 21.117 13.219 21.844C12.7509 22.1585 12.3388 22.5492 12 23ZM20 23H22C22 21.332 23.332 20 25 20C26.668 20 28 21.332 28 23H30C29.997 22.1788 29.7932 21.3709 29.4065 20.6465C29.0197 19.9221 28.4617 19.3033 27.781 18.844C28.523 18.117 29 17.114 29 16C29 13.8 27.2 12 25 12C22.8 12 21 13.8 21 16C21 17.113 21.477 18.117 22.219 18.844C21.5383 19.3033 20.9803 19.9221 20.5935 20.6465C20.2068 21.3709 20.003 22.1788 20 23ZM7 14C8.117 14 9 14.883 9 16C9 17.117 8.117 18 7 18C5.883 18 5 17.117 5 16C5 14.883 5.883 14 7 14ZM25 14C26.117 14 27 14.883 27 16C27 17.117 26.117 18 25 18C23.883 18 23 17.117 23 16C23 14.883 23.883 14 25 14ZM16 17C17.117 17 18 17.883 18 19C18 20.117 17.117 21 16 21C14.883 21 14 20.117 14 19C14 17.883 14.883 17 16 17Z"
                      fill="#fff"
                    />
                  </svg>
                  Campaigns
                </NavLink>
              </li>
            </>
          )}
          {currentRole === "SALES_AGENT" && (
            <>
              {" "}
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "sidebar-link text-white bg-primary-dark"
                      : "sidebar-link text-gray-600 hover:text-primary-dark"
                  }
                  to="/agent/dashboard"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-6 w-6 shrink-0"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    ></path>
                  </svg>
                  Get Lead Info
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "sidebar-link text-white bg-primary-dark"
                      : "sidebar-link text-gray-600 hover:text-primary-dark"
                  }
                  to="/agent/campaigns"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-6 w-6 shrink-0"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    ></path>
                  </svg>
                  Assigned Campaigns
                </NavLink>
              </li>
            </>
          )}
          {currentRole === "SALES_TEAM_LEAD" && (
            <>
              {" "}
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "sidebar-link text-white bg-primary-dark"
                      : "sidebar-link text-gray-600 hover:text-primary-dark"
                  }
                  to="/voicebot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-6 w-6 shrink-0"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    ></path>
                  </svg>
                  Voice Bot
                </NavLink>
              </li>
            </>
          )}

          <hr />
        </ul>
      </li>
      <li className="flex flex-col items-center justify-center">
        <div className="flex justify-center items-center gap-2 mb-2">
          <p className="text-xs font-medium">Made in India, Crafted with</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M22.9128 6.82403C20.5128 0.449029 12.7128 3.29903 12.0003 6.48653C11.0253 3.11153 3.41275 0.599029 1.08775 6.82403C-1.49975 13.7615 11.1003 19.9865 12.0003 20.999C12.9003 20.174 25.5003 13.649 22.9128 6.82403Z"
              fill="#D7598B"
            />
          </svg>
        </div>
        <img className="h-10 w-auto" src="/full_logo.png" alt="TPE Logo" />
      </li>
    </ul>
  );
}
